// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_footer__fLaql {
  position: fixed;
  width: 100vw;
  height: 3rem;
  box-shadow: 0px 10px 5px #8080801a, 0px -3px 5px #8888885c;
  background-color: #fff; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/layout/Footer/styles.module.scss"],"names":[],"mappings":"AACA;EACI,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,0DAAwD;EACxD,sBAAsB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n.footer {\n    position: fixed;\n    width: 100vw;\n    height: 3rem;\n    box-shadow: 0px 10px 5px $grey10, 0px -3px 5px #8888885c;\n    background-color: #fff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `styles_footer__fLaql`
};
export default ___CSS_LOADER_EXPORT___;
